// @flow

import * as React from 'react';
import {useMerchantCurrency} from 'docs/hooks';
import {FormattedNumber} from 'react-intl';

type CurrencyProps = {|
  amount: number,
|};

export const Currency = ({amount}: CurrencyProps) => {
  const currency = useMerchantCurrency();

  if (!currency) {
    // If for some reason we cannot detect the currency, fallback to USD.
    return <span>{amount} USD</span>;
  }

  return (
    <FormattedNumber value={amount} style="currency" currency={currency} />
  );
};
